module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/mv_03-e1a3ca8f626c5f0964a4a5b863608271.jpg";